import { AsyncState, loadingAsyncState } from 'widgets-for-react'
import { footerApi } from './footerApi'

export type FooterState = AsyncState<Links>

export type Links = {
  title: string
  url: string
  column: string
}[]

export const initialFooterState = loadingAsyncState(footerApi)
